import React from "react";
import { Link,NavLink } from "react-router-dom";

export function Explorer(){
  const hiperAncle = { textDecoration: "none"  };

  return (
    <td className="container-tbody" key={2}>
      <section className="navegation_section"  >
        <div >
          <Link to="https://www.google.com" target="_blank" style={hiperAncle}>
            <p  className="div_google">GOOGLE</p>
          </Link>
        </div>
        <div>
          <Link to="https://livenumetal.es" target="_blank" style={hiperAncle}>
            <p className="div_page">LIVE Nü METAL</p>
          </Link>
        </div>
        <div>
          <Link to="https://www.problemasyecuaciones.com" target="_blank" style={hiperAncle}>
            <p className="div_study">MATEMATICAS</p>
          </Link>
        </div>
        <section >
          <p style={{color:"green"}}>
            Coronados Links - URLs 
          </p>
        <div>
          <NavLink to={"/aprende-programacion"} style={hiperAncle}>
            <p className="div_self">PROGRAMAR</p>
          </NavLink>
        </div>
        <div>
          <Link to="https://www.musicaar.com" target="_blank" style={hiperAncle}>
            <p className="div_study">MUSICA ONLINE</p>
          </Link>
        </div>
        <div >
          <NavLink to={"/descargar-juegos-gratis"} style={hiperAncle} >
            <p>DESCARGAR JUEGOS</p>
          </NavLink>
        </div>
        </section>
      </section>
    </td>
  );
}
